import { SubscriptionRestControllerService } from 'generated';
import { put, takeLatest } from 'redux-saga/effects';
import { handleCurrentSubscription } from '../actions';
import configActionTypes from '../types';

export function* getCurrentSubscription(termId) {
  try {
    const currentSubscriptionPlan = yield call(
      apiWrapper(() =>
        SubscriptionRestControllerService.getSubscriptionUsingGet1({ termId: termId }),
      ),
    );
    yield put(handleCurrentSubscription(currentSubscriptionPlan));
  } catch (error) {
    // yield put(getCurrentTermFail(error?.message));
  }
}

export function* onGetCurrentSubscription() {
  yield takeLatest(configActionTypes.GET_CURRENT_SUBSCRIPTION_START, getCurrentSubscription);
}
